import React, { useEffect, useState } from "react";
import { getAllBlogs } from "../../utils/getAllBlogs"; // adjust the path as needed
import { publishBlog } from "../../utils/publishBlog";
import { formatDateDDMMMYYYY } from "../../utils/dateHelpers";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BlogsTable = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState({}); // keeps tra

  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const response = await getAllBlogs();
      // Check if the response is an array.
      if (Array.isArray(response)) {
        setBlogs(response);
      }
      // Alternatively, if response is an object with status and blogs field.
      else if (
        response &&
        (response.status === 1 || response.status === "1") &&
        response.blogs
      ) {
        setBlogs(response.blogs);
      } else {
        console.error("Failed to fetch blogs:", response.message || response);
      }
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleScroll = (e) => {
    // Optional: Add logic here if you need to handle scroll events.
  };

  const handlePublishToggle = async (blog) => {
    const { blogId, isPublished } = blog;
    const newStatus = isPublished === "0" ? "1" : "0";
    // set loading for this blog action
    setActionLoading((prev) => ({ ...prev, [blogId]: true }));
    try {
      const response = await publishBlog(blogId, newStatus);
      if (response.status === 1 || response.status === "1") {
        // Update the local blog state
        setBlogs((prevBlogs) =>
          prevBlogs.map((b) =>
            b.blogId === blogId ? { ...b, isPublished: newStatus } : b
          )
        );
        // Show success toaster message
        toast.success(
          newStatus === "1"
            ? "Blog published successfully!"
            : "Blog unpublished successfully!"
        );
      } else {
        console.error("Failed to update publish status:", response.message);
        toast.error("Failed to update publish status.");
      }
    } catch (error) {
      console.error("Error updating publish status:", error);
      toast.error("Error updating publish status.");
    } finally {
      setActionLoading((prev) => ({ ...prev, [blogId]: false }));
    }
  };

  return (
    <>
      <ToastContainer position="top-right" />
      <div
        className="overflow-y-auto md:max-h-[calc(100vh-245px)] max-h-[calc(100vh-265px)] scroll-bar"
        onScroll={handleScroll}
      >
        <table className="min-w-full text-sm whitespace-nowrap">
          <thead className="bg-[#EFF4FF] text-[#929EB6] border-b border-[#D1DFFC] sticky top-0 z-[2]">
            <tr>
              <th className="p-4 text-left font-medium">S.No</th>
              <th className="p-4 text-left font-medium">Title</th>
              <th className="p-4 text-left font-medium">Slug</th>
              <th className="p-4 text-left font-medium">Author</th>
              <th className="p-4 text-left font-medium">Category</th>
              <th className="p-4 text-left font-medium">Created Date</th>
              <th className="p-4 text-left font-medium">Published Date</th>
              <th className="p-4 text-left font-medium">Action</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="py-5 px-4 text-center text-gray-500">
                  Loading blogs...
                </td>
              </tr>
            ) : blogs.length > 0 ? (
              blogs.map((blog, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-[#F4F7FF]" : "bg-[#EBF1FF]"
                  } border-b border-[#DCE2EC]`}
                >
                  <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                    {index + 1}
                  </td>
                  <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                    {blog.title}
                  </td>
                  <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                    {blog.slug}
                  </td>
                  <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                    {blog.author_name}
                  </td>
                  <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                    {blog.category}
                  </td>
                  <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                    {blog.created_at
                      ? formatDateDDMMMYYYY(blog.created_at)
                      : "-"}
                  </td>
                  <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                    {blog.published_at
                      ? formatDateDDMMMYYYY(blog.published_at)
                      : "-"}
                  </td>
                  <td className="p-4 text-[#193B68] xl:text-sm lg:text-xs">
                    <button
                      onClick={() => handlePublishToggle(blog)}
                      disabled={actionLoading[blog.blogId]}
                      className="bg-blue-600 text-white px-3 py-1 rounded"
                    >
                      {actionLoading[blog.blogId]
                        ? "Processing..."
                        : blog.isPublished === "0"
                        ? "Publish"
                        : "Unpublish"}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="6"
                  className="py-5 px-4 bg-[#F4F7FF]/80 text-center text-gray-500"
                >
                  No blogs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default BlogsTable;
